<template lang="pug">
.agreementOrders
  .planlist
    el-row(style='margin-bottom:1rem')
        //- el-col(:span='9')
        //-     el-card
        //-         div(slot="header")
        //-             span 半小时统计一次当天数据
        //-             el-button.el-icon-refresh(style="float: right; padding: 6px 0;font-size: 1rem;" type="text", size="normal", @click="queryHalfHourData")
        //-             el-select(style="float: right;margin-right: 1rem;" v-model='summary.HALFHOUR_member_type' placeholder='请选择会员业务' @change="queryHalfHourData")
        //-                 el-option( label='WLDS29' value='WLDS29')
        //-                 el-option( label='WLDS29V2' value='WLDS29V2')
        //-         el-row
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="halfHourData.PAY_AND_SIGN?.success" title="支付0.1元成功")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="halfHourData.PAY_AND_SIGN?.refund" title="支付0.1元退款")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="halfHourData.PAY_SIGN?.success" title="35元支付成功")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="halfHourData.PAY_SIGN?.refund" title="35元支付退款")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="halfHourData.SIGN?.success" title="签约中")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="halfHourData.SIGN?.refund" title="已解约")
        //- el-col(:span='9')
        //-     el-card
        //-         div(slot="header")
        //-             span 每天统计一次当月数据
        //-             el-select(style="float: right;" v-model='summary.MONTH_member_type' placeholder='请选择会员业务' @change="queryMonthData")
        //-                 el-option( label='WLDS29' value='WLDS29')
        //-                 el-option( label='WLDS29V2' value='WLDS29V2')
        //-         el-row
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="monthData.PAY_AND_SIGN?.success" title="支付0.1元成功")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="monthData.PAY_AND_SIGN?.refund" title="支付0.1元退款")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="monthData.PAY_SIGN?.success" title="35元支付成功")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="monthData.PAY_SIGN?.refund" title="35元支付退款")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="monthData.SIGN?.success" title="签约中")
        //-             el-col(:span='4', style='text-align:left')
        //-                 el-statistic(:value="monthData.SIGN?.refund" title="已解约")
        el-col(:span='12')
            el-card
                div(slot="header")
                    span 未来电视签约支付情况统计
                    el-button.el-icon-refresh(style="float: right; padding: 6px 0;font-size: 1rem;" type="text", size="normal", @click="queryWLDSData")
                el-row
                    el-col(:span='5', style='text-align:left')
                        el-statistic(:value="wldsData.normal" title="签约中")
                    el-col(:span='5', style='text-align:left')
                        el-statistic(:value="wldsData.stop" title="已解约")
                    el-col(:span='5', style='text-align:left')
                        el-statistic(:value="wldsData.deductable" title="有支付的签约")
                    el-col(:span='5', style='text-align:left')
                        el-statistic(:value="wldsData.preDeductionDate" title="未到首次")
                    el-col(:span='4', style='text-align:left')
                        el-statistic(:value="staticsData.can_pay.count" title="可持续扣款订单")
    el-row(style='margin-bottom:1rem')
        el-col(:span='24' style='text-align:left')
            el-input(style='width:200px;' v-model='paginationInfo.condition.search_key' placeholder='请输入手机号/商户单号' clearable)
            el-date-picker(v-model="create_date[0]", align="right", type="date", placeholder="选择开始时间",
                :picker-options="{disabledDate(time) {return time.getTime() > Date.now();}}")
            el-date-picker(v-model="create_date[1]", align="right", type="date", placeholder="选择结束时间",
                :picker-options="{disabledDate(time) {return time.getTime() > Date.now();}}")
            el-select(v-model='paginationInfo.condition.channel_code' placeholder='请选择渠道' @change='queryList(1)' filterable clearable)
                el-option(label='全部渠道' value)
                el-option(v-for='item in dictData' :key='item.dictdata_value' :label='item.dictdata_name' :value='item.dictdata_value')
            el-select(v-model='paginationInfo.condition.status' placeholder='请选择签约状态' @change='queryList(1)' filterable clearable)
                el-option(label='全部' value)
                el-option(v-for='item in statusList' :key='item.value' :label='item.label' :value='item.value')
            el-button(@click='queryList(1)') 查询
    el-table(:data='tableData', style='width: 100%')
      el-table-column(type='expand')
        template(slot-scope='props')
          el-form
            el-form-item(label='IP:')
              span {{ props.row.ip }}
            el-form-item(label='agreement_no:')
              span {{ props.row.agreement_no }}
            el-form-item(label='user_agent:')
              span {{ props.row.http_user_agent }}
      el-table-column(prop='external_agreement_no', label='签约订单号', align='center', width='150')
      el-table-column(prop='mobile', label='手机号', align='center', width='150')
      el-table-column(label='创建时间', align='center', width='300')
        template(slot-scope='scope') {{ $moment(scope.row.create_date).format('YYYY-MM-DD HH:mm:ss')}}
      el-table-column(prop='member_type', label='会员业务编码', align='center')
      el-table-column(prop='period_rule_params.execute_time', label='首次执行时间', align='center')
      el-table-column(label='订单类型', align='center')
        template(slot-scope='scope')
            span(v-if="scope.row.biz_type == 'U_SHARE_MEMBER'") 优享会员
            span(v-else-if="scope.row.biz_type == 'MEITUAN_HONGBAO'") 美团红包
            span(v-else-if="scope.row.biz_type == 'EASY_ORDER'") 商品订单
            span(v-else-if="scope.row.biz_type == 'EQUITY_MEMBER'") 权益会员
            span(v-else) 无
      el-table-column(label='支付价格', align='center')
        template(slot-scope='scope') {{ scope.row.period_rule_params.single_amount }}元/{{ scope.row.period_rule_params.period_type | periodLabel }}
      el-table-column(label='渠道', align='center')
        template(slot-scope='scope') {{ getDictName(scope.row.channel_code) }}
      el-table-column(label='办理账号', align='center')
        template(slot-scope='scope') {{ getAccountChannelName(scope.row.account_channel) }}
      el-table-column(label='订单状态', align='center')
        template(slot-scope='scope')
            span(v-if="scope.row.status == 'NORMAL'") 已签约
            span(v-else-if="scope.row.status == 'TEMP'") 暂存
            span(v-else-if="scope.row.status == 'STOP'") 暂停
      el-table-column(label='操作', align='center')
        template(slot-scope='scope')
            el-popover(placement="left", width="800", trigger="click" @show="getAgreementPayOrders(scope.row)")
                el-table(:data="currentShowPayOrders", v-loading="isPayOrderLoading")
                    el-table-column(prop='out_trade_no', label='订单号')
                    el-table-column(prop='create_date', label='支付发起时间')
                        template(slot-scope='scope') {{ $moment(scope.row.create_date).format('YYYY-MM-DD HH:mm:ss')}}
                    el-table-column(label='支付状态')
                        template(slot-scope='scope')
                            span(v-if="scope.row.trade_status == 'TRADE_SUCCESS'") 支付成功
                            span(v-else-if="scope.row.trade_status == 'PRE_CREATE'") 预创建
                            span(v-else-if="scope.row.trade_status == 'PRE_CREATE'") 交易关闭
                            span(v-else-if="scope.row.trade_status == 'TRADE_FINISHED'") 交易完结
                            span(v-else-if="scope.row.trade_status == 'WAIT_BUYER_PAY'") 交易创建
                    el-table-column(prop='external_agreement_no', label='签约订单号')
                el-button(slot="reference", type="warning") 支付记录
            el-popover(placement="left", width="800", trigger="click" @show="queryStatus(scope.row)", size="mini")
                el-card
                    ul
                        li(v-for="key in Object.keys(currentAgreementStatus)", :key="key") {{key}}: {{currentAgreementStatus[key]}}
                el-button(slot="reference", type="primary", size="mini") 签约状态
            el-popconfirm(title="确定尝试续费？", @confirm="handlePay(scope.row)")
                el-button(slot="reference", type="danger", size="mini") 续费
    el-pagination(
        @size-change='handleSizeChange',
        @current-change='handleCurrentChange',
        :current-page='paginationInfo.pageNo',
        :page-sizes='[10, 20, 50, 100]',
        :page-size='paginationInfo.pageSize',
        :total='paginationInfo.total',
        layout='total, sizes, prev, pager, next, jumper'
    )
</template>

<script>
export default {
    components: {},
    data() {
        return {
            summary: {
                HALFHOUR_member_type: 'WLDS29',
                MONTH_member_type: 'WLDS29'
            },
            monthData: {},
            halfHourData: {},
            orderDoctData: [],
            wldsData: {},
            dictData: [],
            staticsData: {
                can_pay: {
                    count: 0
                }
            },
            statusList: [
                {
                    label: '已签约',
                    value: 'NORMAL'
                },
                {
                    label: '暂停',
                    value: 'STOP'
                }
            ],
            accountChannelList: [],
            create_date: [new Date(), new Date()],
            paginationInfo: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
                condition: {
                    out_trade_no: '',
                    account_channel: '',
                    create_date: '',
                    trade_status: '',
                    biz_type: '',
                    channel_code: ''
                }
            },
            tableData: [],
            formData: {
            },
            isPayOrderLoading: false,
            currentShowPayOrders: [],
            currentAgreementStatus: {}
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryList(1);
        this.getDict();
        this.getAccountChannel();
        this.getOrderDoctData();
        this.queryHalfHourData()
        this.queryMonthData()
        this.queryWLDSData()
    },
    mounted() {
    },
    methods: {
        getKQStatics() {
            this.$service.OnlineOrderService
                .getWLDSStatics()
                .then((res) => {
                    if (res.data.code === 0) {
                        this.staticsData = res.data.data
                    }
                })
        },
        queryHalfHourData() {
            this.halfHourData = {}
            this.$service.OnlineOrderService
                .alInfluxDBQuery({
                    type: 'HALFHOUR',
                    member_type: this.summary.HALFHOUR_member_type
                }).then(res => {
                    if (res.data.code === 0) {
                        this.halfHourData = res.data.data
                        this.$message.success('半小时统计当天数据已读取成功。')
                    } else {
                        this.$message.warning(res.data.message)
                    }
                })
        },
        queryWLDSData() {
            this.getKQStatics()
            this.halfHourData = {}
            this.$service.OnlineOrderService
                .alInfluxDBQuery({
                    stats_type: 'wlds'
                }).then(res => {
                    if (res.data.code === 0) {
                        this.wldsData = res.data.data
                        this.$message.success('签约支付状态读取成功。')
                    } else {
                        this.$message.warning(res.data.message)
                    }
                })
        },
        queryMonthData() {
            this.monthData = {}
            this.$service.OnlineOrderService
                .alInfluxDBQuery({
                    type: 'MONTH',
                    member_type: this.summary.MONTH_member_type
                }).then(res => {
                    if (res.data.code === 0) {
                        this.monthData = res.data.data
                        this.$message.success('凌晨3点统计当月数据已读取成功。')
                    } else {
                        this.$message.warning(res.data.message)
                    }
                })
        },
        getAccountChannelName(str) {
            let name = "无";
            this.accountChannelList.forEach(item => {
                if (item.dictdata_value == str) {
                    name = item.dictdata_name;
                }
            });
            return name;
        },
        getDictName(str) {
            let name = "无";
            this.dictData.forEach(item => {
                if (item.dictdata_value == str) {
                    name = item.dictdata_name;
                }
            });
            return name;
        },
        getDict() {
            this.$service.CommonService
                .getDict({ dict: 'AdChannelInfos' })
                .then(res => {
                    if (res.data.code === 0) {
                        this.dictData = res.data.data.dict_data;
                    }
                })
        },
        getOrderDoctData() {
            this.$service.CommonService
                .getDict({ dict: 'PayBizTypes' })
                .then(res => {
                    if (res.data.code === 0) {
                        this.orderDoctData = res.data.data.dict_data;
                    }
                })
        },
        getAccountChannel() {
            this.$service.CommonService
                .getDict({ dict: 'AlipayAccountOptions' })
                .then(res => {
                    if (res.data.code === 0) {
                        this.accountChannelList = res.data.data.dict_data;
                    }
                })
        },
        queryList(pageNo) {
            if (this.create_date.length >= 2 && this.create_date[0] && this.create_date[1]) {
                this.paginationInfo.condition.create_date = [this.create_date[0], this.create_date[1]];
            } else {
                this.paginationInfo.condition.create_date = null;
            }
            this.paginationInfo.pageNo = pageNo || this.paginationInfo.pageNo;
            this.getAgreementOrdersAL()
        },
        getAgreementPayOrders(agreement) {
            this.isPayOrderLoading = true
            this.$service.OnlineOrderService
                .getAgreementPayOrders(agreement._id)
                .then(res => {
                    if (res.data.code === 0) {
                        this.currentShowPayOrders = res.data.data
                    }
                })
                .finally(() => {
                    this.isPayOrderLoading = false
                })
        },
        handlePay(agreement) {
            this.$service.OnlineOrderService
                .agreementPay(agreement._id)
                .then((res) => {
                    if (res.data.code === 0) {
                        this.$message.info(res.data.data)
                    }
                })
            
        },
        queryStatus(agreement) {
            this.currentAgreementStatus = {}
            this.$service.OnlineOrderService
                .getAgreementStatus(agreement._id)
                .then((res) => {
                    if (res.data.code === 0) {
                        this.currentAgreementStatus = res.data.data
                        this.queryList()
                    }
                })
            
        },
        handleSizeChange(val) {
            window.console.log(`每页 ${val} 条`);
            this.paginationInfo.pageSize = val;
            this.paginationInfo.pageNo = 1;
            this.getAgreementOrdersAL();
        },
        handleCurrentChange(val) {
            window.console.log(`当前页: ${val}`);
            this.paginationInfo.pageNo = val;
            this.getAgreementOrdersAL();
        },
        getAgreementOrdersAL() {
            this.$service.OnlineOrderService
                .getAgreementOrdersAL(this.paginationInfo)
                .then(res => {
                    if (res.data.code === 0) {
                        let dataInfo = res.data.data
                        this.paginationInfo.total = dataInfo.total;
                        this.tableData = dataInfo.agreements;
                    }
                })
        },
    },
    filters: {
        periodLabel(value) {
            let label = ''
            switch(value) {
                case 'MONTH':
                    label = '月'
                    break;
                case 'DAY':
                    label = '日'
                    break;
            }
            return label
        }
    }
}
</script>
<style lang='less' scoped>
.agreementOrders {
    ::v-deep .el-form-item__label {
        font-weight: bold;
    }
}
</style>